enum EsourceTypeEnum {
    TPOS = 'POS Terminal',
    ECOM = 'E-Commerce',
    ITAP = 'TOP - iOS',
    TOPH = 'TOP - Android'
}
enum DeviceModelEnum {
    CLOUD_POS = 'Cloud POS'
}

enum SteamParamEnum {
    SPIN_CLOUD_VALUE = '2'
}

interface IsourceType {
    displayName: string;
    name: string;
}

function getSourceNames() {
    const keys = Object.keys(EsourceTypeEnum);
    const values = Object.values(EsourceTypeEnum);
    let sources: IsourceType[] = []
    keys.forEach((key, index) => {
        let data = { displayName: values[index], name: key };
        sources.push(data);
    });
    return sources;
}

export class AppConstants {
    public static sourceType: IsourceType[] = getSourceNames();
    public static EsourceType = EsourceTypeEnum;
    public static DeviceModel = DeviceModelEnum;
    public static SteamParam = SteamParamEnum;
}

export const DATE_FILTER_OPTIONS = [
    { displayName: 'Today', name: 'Today' },
    { displayName: 'Yesterday', name: 'Yesterday' },
    { displayName: 'This Week', name: 'Week' },
    { displayName: 'Last 30 days', name: "Month" },
    { displayName: 'Custom', name: "Custom" },
    { displayName: 'None', name: 'None' }
]

export const TIME_ZONE_TYPES = [
    {
      val: 'txDate',
      text: "Gateway Time (EST)"
    },
    {
      val: 'posRequestDate',
      text: "POS Time"
    }];

export const PARAMS_HED = {
  "/paymentapi/process-transaction": "TxDetail.Tpn"
}    

export const MERCHANT_INTEGRATED = {
  message: "Extra 360 Integration is successful.",
  status: "Success",
};

export const MERCHANT_INTEGRATION_FAILURE = {
  message:
    "Unable to add Extra 360 Integration at this time. Please try again later by editing the merchant details",
  status: "Error",
};

export const STORE_INTEGRATED = {
  message: "Edit Store Integration is successful.",
  status: "Success",
};

export const STORE_INTEGRATED_FAILURE = {
  message: "Edit Store Integration is failed.",
  status: "Error",
};

export const MERCHANT_REMOVE_INTEGRATION = {
    message: "Extra 360 Integration removal is successful.",
    status: "Success",
}

export const MERCHANT_REMOVE_INTEGRATION_FAILURE = {
    message: "Extra 360 Integration removal has failed. Please try again in sometime",
    status: "Error",
}

export const PARAM_BOOLEAN = {
  enabled : '1' ,
  disabled : '0'
}

export const ACH_ALTERNATE_PROCESSOR_CODE = {
  PAYA: 'PAYAACH',
  VERICHECK: 'VERICHECKACH',
  ACH: 'ACH',
} as const;

export type AchAlternateProcessorCode =
  (typeof ACH_ALTERNATE_PROCESSOR_CODE)[keyof typeof ACH_ALTERNATE_PROCESSOR_CODE];

export const ACH_ALTERNATE_PROCESSOR_CODES: readonly string[] = [
  ACH_ALTERNATE_PROCESSOR_CODE.PAYA,
  ACH_ALTERNATE_PROCESSOR_CODE.VERICHECK,
];

export const TEMPLATE_FEATURES = ['CREATE_TEMPLATE', 'EDIT_TEMPLATE', 'DELETE_TEMPLATE',"VIEW_BILLING","EDIT_BILLING"];
